import React from "react"
import clsx from "clsx"
import * as styles from "./icons.module.scss"

export const EmptyIcon = ({ variant }: { variant?: string }) => (
  <svg
    width="24"
    height="24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={clsx(styles.empty, variant && styles[variant])}
  >
    <path
      d="M18 .8H6A5.2 5.2 0 0 0 .8 6v12A5.2 5.2 0 0 0 6 23.2h12a5.2 5.2 0 0 0 5.2-5.2V6A5.2 5.2 0 0 0 18 .8Z"
      stroke="#FF4E50"
      strokeWidth="1.6"
    />
  </svg>
)
